import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'

import { apiSlice } from '@/services/api'
import authSlice from './slices/authSlice'
import interviewSlice from './slices/interviewSlice'
import uiSlice from './slices/uiSlice'

export const store = configureStore({
  reducer: {
    // API slice for RTK Query
    api: apiSlice.reducer,
    
    // Feature slices
    auth: authSlice,
    interview: interviewSlice,
    ui: uiSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }).concat(apiSlice.middleware),
  devTools: import.meta.env.NODE_ENV !== 'production',
})

// Enable listener behavior for the store
setupListeners(store.dispatch)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

// Export pre-typed hooks
export { useAppDispatch, useAppSelector } from '@/hooks/redux'